export default {
      id: "table-row-after-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#table-row-after-usage",
      toString: function () {
        return this.url;
      }
    }